export const APP_TOKEN_KEY = "app-token";
export const APP_TOKEN_P_KEY = "app-token-p";
export const APP_USER_KEY = "app-user";
export const APP_TRANS_DEBUG_KEY = "app-trans-debug";
export const APP_USER_LOCALE = "app-user-locale";
export const APP_SIDEBAR_COLLAPSED = "app-sidebar-collapsed";
export const APP_SEL_SC = "app-sel-sc";
export const APP_THREAD_INFO = "app-thread-info";
